import React, { useContext } from 'react';

import { ProductPricingContext, useProductPricingInternal } from './UseProductPricing';

const initialContext: ProductPricingContext = {
  productPricings: [],
};

const ProductPricing = React.createContext<ProductPricingContext>(initialContext);
ProductPricing.displayName = 'ProductPricing';

export const useProductPricing = () => useContext(ProductPricing);

export const ProductPricingProvider: React.FC = ({ children }) => {
  const value = useProductPricingInternal();

  return (
    <ProductPricing.Provider value={value}>
      {children}
    </ProductPricing.Provider>
  );
};

export const ProductPricingConsumer = ProductPricing.Consumer;
